import { render, staticRenderFns } from "./DefaultHospitalDownloadPage.vue?vue&type=template&id=01a1c107&scoped=true"
import script from "./DefaultHospitalDownloadPage.vue?vue&type=script&lang=js"
export * from "./DefaultHospitalDownloadPage.vue?vue&type=script&lang=js"
import style0 from "./DefaultHospitalDownloadPage.vue?vue&type=style&index=0&id=01a1c107&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1c107",
  null
  
)

export default component.exports